<template>
	<vx-card no-shadow>
		<div class="export-table">
			<vs-table :data="routed_visit_points_local" v-model="selectedRows">
				{{ routed_visit_points_local }}
				<template slot="header">
					<slot name="header"></slot>
				</template>

				<template slot="thead">
					<vs-th> N </vs-th>
					<vs-th>{{ thead_property_names.type }}</vs-th>
					<vs-th>{{ thead_property_names.identification }}</vs-th>
					<vs-th> {{ thead_property_names.estimatedTimeArrival }} </vs-th>
					<vs-th> {{ thead_property_names.waitingTime }} </vs-th>
					<vs-th> {{ thead_property_names.estimatedStartTask }} </vs-th>
					<vs-th> {{ thead_property_names.timeService }} </vs-th>
					<vs-th> {{ thead_property_names.estimatedDepartureTime }} </vs-th>
					<vs-th> {{ thead_property_names.distanceFromPrevious }} </vs-th>
					<vs-th> {{ thead_property_names.totalDistanceTraveled }} </vs-th>
					<vs-th v-if="typeRouting === 'TOUR_PLANNING'"> {{ thead_property_names.territoryId }} </vs-th>
					<vs-th>{{ thead_property_names.actions }}</vs-th>
				</template>

				<template slot-scope="{data}">
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td>
							{{ tr.type === "depot" ? "🏬" : tr.type === "break" ? "⏳" : tr.indexPoint }}
						</vs-td>
						<vs-td>{{ getTypeLabel(tr.type) }}</vs-td>
						<vs-td>{{ tr.identification }}</vs-td>
						<vs-td>{{ tr.estimated_time_arrival }}</vs-td>
						<vs-td>{{ tr.waiting_time }}</vs-td>
						<vs-td>{{ tr.estimated_start_task }}</vs-td>
						<vs-td>{{ tr.time_service }}</vs-td>
						<vs-td>{{ tr.estimated_time_depart }}</vs-td>
						<vs-td>{{ parseFloat(tr.distance_from_previous).toFixed(2) || 0 }}</vs-td>
						<vs-td>{{ parseFloat(tr.total_distance_traveled).toFixed(2) || 0 }}</vs-td>
						<vs-td v-if="typeRouting === 'TOUR_PLANNING'">{{ tr.territory_id }}</vs-td>
						<vs-td class="flex items-center justify-center">
							<feather-icon
								v-if="tr.type != 'depot' && tr.type != 'break'"
								icon="EyeIcon"
								svgClasses="h-6 w-6 hover:text-warning cursor-pointer font-bold"
								:title="thead_property_names.titleButton"
								@click="seeDetailInformation(tr)"
							/>
						</vs-td>
					</vs-tr>
				</template>
			</vs-table>
		</div>
		<vs-popup :title="null" :active.sync="popupActive" style="z-index: 54000">
			<vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
				<vs-tab v-show="hasAdditionalData" :label="thead_property_names.additionalFields | capitalize">
					<vx-card no-shadow card-border class="mb-base">
						<table
							v-if="
								visitPointDetails.additional_data &&
								Object.keys(visitPointDetails.additional_data).length > 0
							"
						>
							<caption></caption>
							<thead>
								<tr>
									<th scope="col"></th>
								</tr>
							</thead>
							<tr v-for="(value, label) in visitPointDetails['additional_data']" :key="label">
								<td class="font-semibold">{{ label | capitalize }}:</td>
								<td>{{ value }}</td>
							</tr>
						</table>
					</vx-card>
				</vs-tab>
				<vs-tab v-show="hasDemand" :label="thead_property_names.demands">
					<vs-table :data="visitPointDetails.demand" noDataText="">
						<template slot="thead">
							<vs-th>{{ thead_property_names.name }}</vs-th>
							<vs-th>{{ thead_property_names.capacityValue }}</vs-th>
						</template>
						<template slot-scope="{data}">
							<vs-tr :key="indextr" v-for="(tr, indextr) in data">
								<vs-td :data="tr.name">
									<div class="flex items-center">
										<span>{{ tr.name }}</span>
									</div>
								</vs-td>
								<vs-td :data="tr.amount">{{ tr.amount }}</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</vs-tab>
				<vs-tab v-show="hasSkills" :label="thead_property_names.skills">
					<vs-table :data="visitPointDetails.skills" noDataText="">
						<template slot="thead">
							<vs-th>{{ thead_property_names.name }}</vs-th>
						</template>
						<template slot-scope="{data}">
							<vs-tr :key="indextr" v-for="(tr, indextr) in data">
								<vs-td :data="tr">{{ tr }}</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</vs-tab>
				<vs-tab v-show="hasAllowedVehicles" :label="thead_property_names.permittedVehicles">
					<vs-table :data="visitPointDetails.allowed_vehicles" noDataText="">
						<template slot="thead">
							<vs-th>{{ thead_property_names.identification }}</vs-th>
						</template>
						<template slot-scope="{data}">
							<vs-tr :key="indextr" v-for="(tr, indextr) in data">
								<vs-td :data="tr">{{ tr }}</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</vs-tab>
				<vs-tab v-show="hasTimeWindows" :label="thead_property_names.timeWindows">
					<vs-table :data="visitPointDetails.time_windows" noDataText="">
						<template slot="thead">
							<vs-th>{{ thead_property_names.initDate }}</vs-th>
							<vs-th>{{ thead_property_names.endDate }}</vs-th>
						</template>
						<template slot-scope="{data}">
							<vs-tr :key="indextr" v-for="(tr, indextr) in data">
								<vs-td :data="tr.init_time_window">{{ tr.init_time_window }}</vs-td>
								<vs-td :data="tr.end_time_window">{{ tr.end_time_window }}</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</vs-tab>
			</vs-tabs>
		</vs-popup>
	</vx-card>
</template>

<script>
export default {
	props: {
		routed_visit_points: {
			type: Array,
			default: () => [],
		},
		thead_property_names: {
			type: Object,
			default: {},
		},
		typeRouting: {
			type: String,
			default: "OPENROUTE",
		},
	},
	data() {
		return {
			selectedRows: [],
			visitPointDetails: {},
			popupActive: false,
			activeTab: 0,
			hasAdditionalData: false,
			hasDemand: false,
			hasSkills: false,
			hasAllowedVehicles: false,
			hasTimeWindows: false,
		};
	},
	computed: {
		routed_visit_points_local() {
			return this.formarRoutedVP(this.routed_visit_points);
		},
		getTypeLabel() {
			return (type) => {
				switch (type) {
					case "break":
						return this.thead_property_names.Break;
					case "depot":
						return this.thead_property_names.Depot;
					case "pickup":
						return this.thead_property_names.Pickup;
					case "delivery":
						return this.thead_property_names.Delivery;
					default:
						return type;
				}
			};
		},
	},
	methods: {
		/**
		 * @description Funcion para formatear la data de tal modo que agreguemos los index de los elementos
		 * solo de tipo point en una propiedad llamada indexPoint
		 * @param {Array} routedVisitPoints array de puntos de visita ruteados
		 */
		formarRoutedVP(routedVisitPoints = []) {
			let indexPoint = 0;
			return routedVisitPoints.map((rv) => {
				if (rv.type === "point" || rv.type === "pickup" || rv.type === "delivery") {
					indexPoint += 1;
					rv["indexPoint"] = indexPoint;
				}
				return rv;
			});
		},
		seeDetailInformation(data) {
			this.visitPointDetails = data;
			this.hasAdditionalData = this.hasPropertyWithLength("additional_data");
			this.hasDemand = this.hasPropertyWithLength("demand");
			this.hasSkills = this.hasPropertyWithLength("skills");
			this.hasAllowedVehicles = this.hasPropertyWithLength("allowed_vehicles");
			this.hasTimeWindows = this.hasPropertyWithLength("time_windows");
			this.popupActive = true;
		},
		hasPropertyWithLength(propertyName) {
			const prop = this.visitPointDetails[propertyName];
			if (prop === null) {
				return false;
			}
			return Object.entries(prop || {}).length > 0;
		},
	},
	watch: {
		selectedRows(val) {
			this.$emit("handleSelectedEmit", val);
		},
	},
};
</script>
